import { apiSlice } from '@src/services/api/apiSlice';
import {
    CountryListParams,
    CountryListResponse,
} from './countryListApiSliceTypes';

const tenantCountryListApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getTenantCountryList: builder.query<
            CountryListResponse,
            CountryListParams
        >({
            query: (params) => {
                return {
                    url: '/tenant-data/countries',
                    method: 'GET',
                    headers: {
                        'Accept-Language': params.acceptLanguage ?? 'en',
                    },
                };
            },
            providesTags: (response) => {
                return response
                    ? [
                          ...response.data.map((country) => ({
                              type: 'tenantCountries' as const,
                              id: country.id,
                          })),
                          { type: 'tenantCountries', id: 'LIST' },
                      ]
                    : [{ type: 'tenantCountries', id: 'LIST' }];
            },
        }),
    }),
    overrideExisting: true,
});

export const {
    useGetTenantCountryListQuery,
    useLazyGetTenantCountryListQuery,
} = tenantCountryListApiSlice;
